import PayBtn from './PayBtn';

export default PayBtn;
